import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=d3e79118&scoped=true&"
import script from "./queue.vue?vue&type=script&lang=ts&"
export * from "./queue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e79118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3e79118')) {
      api.createRecord('d3e79118', component.options)
    } else {
      api.reload('d3e79118', component.options)
    }
    module.hot.accept("./queue.vue?vue&type=template&id=d3e79118&scoped=true&", function () {
      api.rerender('d3e79118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/synchronization/queue.vue"
export default component.exports